module.exports = __webpack_public_path__ + "img/img14.a7dce581.svg";